import moment from 'moment';
const axios = require('axios');
const cors = require("cors");

export async function getAgentSOADetails(AgentSOAWebLink, url) {
    let resData1 = null;
    //https://api.chumit.com/DevWebSOA/api/AgentDetails?npn=11111
    // await axios.get("http://localhost:54101/api/AgentDetails?AgentSOAWebLink=" + AgentSOAWebLink,
    await axios.get(url + "api/AgentDetails?AgentSOAWebLink=" + AgentSOAWebLink,
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
        }
    ).then(res => {
        console.log(res.data);
        resData1 = res.data.Payload;
    }
    ).catch(err => {
        console.log(err);
    });
    return resData1;
}

export async function getClientSOADetails(soaid, url) {
    let resData = null;
    await axios.get(url + "api/ClientSOA?soaid=" + soaid,
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
        }
    ).then(res => {
        console.log(res.data);
        resData = res.data.Payload;
    }
    ).catch(err => {
        console.log(err);
    });
    return resData;
}

export async function submitClientSOADetails(soa, url) {
    let status = null;
    let AgentNPN = soa.AgentNPN;
    let ClientName = soa.ClientSOADetails.ClientFullName;
    //await axios.post("http://localhost:54101/api/ClientSOA", soa,
    await axios.post(url + "api/ClientSOA", soa,
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
        }
    ).then((res) => {
        downloadPDF(res.data.Payload.FileString, AgentNPN, ClientName);
        status = res.data.StatusCode;
    })
        .catch(err => {
            console.log(err);
            status = 200;
        });
    return status;
}

function downloadPDF(pdf, AgentNPN, ClientName) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = "SOA-" + AgentNPN + "-" + ClientName + "-" + moment().unix() + ".pdf";

    const byteCharacters = atob(pdf);

    let byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
        downloadLink.download = fileName;
        downloadLink.href = window.webkitURL.createObjectURL(blob);
        downloadLink.click();
    }

}